module.exports = __webpack_public_path__ + "img/koala-img.dbf024f6.png";